import { Record } from 'immutable'

const ReportSchemeRowRecord = Record({
  balanceType: '',
  blankDimensionValueFilters: [],
  companyLevelDimensions: [],
  children: undefined,
  comment: null,
  dimensionCode: null,
  editable: false,
  endAccount: undefined,
  formula: null,
  hideAccountIntervals: false,
  id: undefined,
  isCollapsed: true,
  level: undefined,
  name: '',
  operativeItemDataType: '',
  order: 0,
  parentId: undefined,
  parentRowId: null,
  path: '',
  previousMonthCount: 0,
  previousMonthCountType: '',
  reportSchemeRowType: '',
  rowFactor: 0,
  rowId: '',
  rowType: '',
  startAccount: undefined,
  showForm: undefined,
  valueMeters: undefined,
  visible: true,
  dataGroupId: '',
  dimensionValueFilters: [],
  dimensionFilters: [],
  reportingGroupFilters: [],
  discludedCompanies: [],
})

export default ReportSchemeRowRecord
